import type { EditablePalette, TextureType } from './types/heatmap.types';
import { UnreachableCaseError } from 'ts-essentials';

export type HeatmapPaletteInterpolation = 'gradient' | 'step';

export type HeatmapPaletteAnalyticsAction =
  | 'created'
  | 'edited'
  | 'deleted'
  | 'setAsDefault'
  | 'changed';

export interface HeatmapPaletteAnalyticsProperties {
  readonly paletteCount: number;
  readonly stopCount: number;
  readonly interpolation: HeatmapPaletteInterpolation;
  readonly isDefault: boolean;
}

export type HeatmapPaletteAnalyticsPayload =
  HeatmapPaletteAnalyticsProperties & {
    readonly action: HeatmapPaletteAnalyticsAction;
  };

export function heatmapPaletteInterpolation(
  textureType: TextureType
): HeatmapPaletteInterpolation {
  return textureType === 'stepped' ? 'step' : 'gradient';
}

export function heatmapPaletteAnalyticsProperties(
  palette: Pick<EditablePalette, 'stops' | 'textureType' | 'default'>,
  paletteCount: number,
  isDefault: boolean = palette.default
): HeatmapPaletteAnalyticsProperties {
  return {
    paletteCount,
    stopCount: palette.stops.length,
    interpolation: heatmapPaletteInterpolation(palette.textureType),
    isDefault,
  };
}

export function paletteCountAfterWrite(
  palettes: readonly Pick<EditablePalette, 'id'>[],
  paletteId: string,
  mode: 'create' | 'delete' | 'unchanged'
): number {
  const inList = palettes.some((palette) => palette.id === paletteId);
  switch (mode) {
    case 'create':
      return inList ? palettes.length : palettes.length + 1;
    case 'delete':
      return inList ? palettes.length - 1 : palettes.length;
    case 'unchanged':
      return palettes.length;
    default:
      throw new UnreachableCaseError(mode);
  }
}
